bovoApp.
factory('CustomerUser', ['$http', function($http) {
    return {
      init: function(data) {
        return $http.post('api/customer-users',data);
      },
      newUser: function() {
        return $http.get('api/new-customer-user');
      },
      show: function(e) {
        return $http.get('api/customer-user/'+e);
      },
      saveUser: function(data) {
        return $http.post('api/save-customer-user',data);
      },
      deleteUser: function(data) {
        return $http.post('api/delete-customer-user',data);
      },
      updateUser: function(data) {
        return $http.post('api/update-customer-user-company',data);
      }
    };
}]);